import {
  FETCH_ANEES_VOUCHERS_DATA,
  FETCH_ANEES_VOUCHERS_SUCCESS,
  FETCH_ANEES_VOUCHERS_FAILURE,
} from "./actionTypes";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const aneesVouchers = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ANEES_VOUCHERS_DATA:
      return { ...state, loading: true, error: null };
    case FETCH_ANEES_VOUCHERS_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case FETCH_ANEES_VOUCHERS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default aneesVouchers;
